export const messageValidator = {
    email_required: "* Email không được bỏ trống",
    email_invalid: "* 이메일 형식이 올바르지 않습니다. 다시 확인해주세요.",
    password_required: "* Mật khẩu không được bỏ trống",
    password_min: "* 비밀번호는 6 자 이상이어야합니다.",
    user_name_required: "* Tên hiển thị không được bỏ trống",
    user_name_size: "* 표시 이름이 3-15 자이어야합니다."
}